import React from 'react';

import Button from '../../../common/components/Button/Button';
import { GetProjectDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useNavigation } from '../../../common/navigation';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface SpecialInvoicingButtonProps {
  project: GetProjectDto;
}
export const SpecialInvoicingButton: React.FC<
  SpecialInvoicingButtonProps
> = props => {
  const nav = useNavigation();
  const { t, tk } = useTranslation('projectLng');

  const handleClick = () => {
    nav.specialInvoicingEditor('utworz', props.project.id);
  };

  return (
    <Button variant="outline-primary" onClick={handleClick}>
      {t(tk.projects.specialInvoicingApplication)}
    </Button>
  );
};
